<template>
  <div class="columns is-multiline">
    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-content">
          <input type="hidden" v-model="id" v-if="id = $session.get('user').id">
          <input type="hidden" v-model="admin" v-if="admin = $session.get('user').admin">
          <h3 class="is-size-3">Salidas</h3>
          <b-field class="is-12" type="is-success" >
            <b-input placeholder="Criterio de búsqueda..." type="search" icon="magnify" v-model="fil" rounded></b-input>
            <p class="control">
                <button class="button is-success" @click="filter()">Buscar</button>
            </p>
          </b-field>
          <b-table :data="table.data" :striped="true" :hoverable="true" :paginated="true" :per-page="8">
              <template slot-scope="props">
                <b-table-column field="nit fundacion" label="Nit fundación" sortable>
                    {{ props.row.fnit }} {{ props.row.fname }}
                </b-table-column>
                <!-- <b-table-column field="nombre fundacion" label="Nombre fundación" sortable>
                    {{ props.row.fname }}
                </b-table-column> -->
                <b-table-column field="nit transaccion" label="Nit transacción" sortable>
                    {{ props.row.tnit }}
                </b-table-column>
                <b-table-column field="nombre transaccion" label="Nombre transacción" sortable>
                    {{ props.row.tname }}
                </b-table-column>
                <b-table-column field="fecha" label="Fecha" sortable>
                    {{ props.row.initial_date }} to {{ props.row.final_date }}
                </b-table-column>
                <b-table-column field="retencion" label="Retención" sortable>
                    {{ props.row.trete }}
                </b-table-column>
                <b-table-column field="municipio" label="Municipio" sortable>
                    {{ props.row.municipality }}
                </b-table-column>
                <b-table-column field="actions" label="Acción" sortable>
                  <a class="button is-danger is-radiusless" @click="generatePDF(props.row.tnit,props.row.municipality,props.row.trete,props.row.initial_date,props.row.fnit)">
                    <font-awesome-icon :icon="['fa','file-pdf']"/></a>
                </b-table-column>
              </template>
            </b-table>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import OutputsService from '@/services/OutputsService'
import env from '@/env'
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
export default {
  name: 'dashboard',
  mixins: [xMisc, sGate],
  components: {
  },
  data () {
    return {
      fil: '',
      table: {
        data: []
      },
      admin: 0,
      id: 0

    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      var outputs = []
      if (this.admin) {
        outputs = await OutputsService.fetchOutputs(this.$session.get('user').token)
      } else {
        outputs = await OutputsService.fetchOutputs2(this.id, this.$session.get('user').token)
      }

      for (var i = 0; i < outputs.data.length; i++) {
        this.table.data.push(outputs.data[i])
      }
    },
    async filter () {
      this.table.data = []
      var outputs = []

      var param = null

      if (this.fil !== '') {
        param = this.fil
      }

      if (this.admin) {
        outputs = await OutputsService.filter(param, this.$session.get('user').token)
      } else {
        outputs = await OutputsService.filter2(this.id, param, this.$session.get('user').token)
      }
      // var outputs = await OutputsService.filter(param, this.$session.get('user').token)
      for (var i = 0; i < outputs.data.length; i++) {
        this.table.data.push(outputs.data[i])
      }
    },
    async generatePDF (nit, municipality, retencion, año, fundacion) {
      var url = env.API_BASE_URL + '/outputs/PDF/' + nit + '/' + municipality + '/' + retencion + '/' + año + '/' + fundacion + '/' + 0

      this.$dialog.confirm({
        message: '<iframe width="800" height="500" src="' + url + '" style="min-height: 25rem;"></iframe>',
        cancelText: 'No',
        confirmText: 'Descargar',
        type: 'is-success',
        onConfirm: () => window.open(env.API_BASE_URL + '/outputs/PDF/' + nit + '/' + municipality + '/' + retencion + '/' + año + '/' + fundacion + '/' + 1, '_blank')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/output/Output.vue